export default function ({ correct }, indices) {
	for (let i = 0; i < indices.length; ++i)
		if (correct[indices[i]] !== i) return false;
	return true;
};